import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { appConfig } from '../../app-config';

@Component({
  selector: 'app-system-page',
  imports: [ButtonModule],
  templateUrl: './system-page.component.html',
  styleUrl: './system-page.component.css',
})
export class SystemPageComponent {
  appName = appConfig.appName;
}
